import { Announcement } from '../../../models/announcement'
import { PrivateMessage } from '../../../models/privateMessage'
import { Role, RoleGroup } from '../../../models/functional/role'
import { SmsMessage } from '../../../models/smsMessage'
import { User } from '../../../models/user'
import { MessagingTabName } from './messaging-page.component'
import { AssistanceFeedbackMessage } from '../../../models/AssistanceFeedbackMessage'
import { UsersService } from '../../../services/domain/users.service'

export interface MessageMode {
  subjectAllowed: boolean
  hasRecipient: boolean
  attachmentAllowed: boolean
  type: MessageType
  name: string
  nameInDeclination: string
  order: number
  allowedRoles: Role[]
}

export enum MessageType {
  announcement,
  privateMessage,
  sms,
}

interface CreateMessageOpts {
  title: string
  content: string
  publishedAt: Date
  publishedByUser: User
  recipient: User
  parentMessage?: PrivateMessage
  assistance_feedback_message?: AssistanceFeedbackMessage
  isFeedback: boolean
  attachmentUri
  user?: User
}

export class MessageModes {
  static MODES: MessageMode[] = [
    {
      type: MessageType.announcement,
      subjectAllowed: true,
      name: 'oznámení',
      nameInDeclination: 'oznámení',
      hasRecipient: false,
      order: 0,
      attachmentAllowed: true,
      allowedRoles: [...RoleGroup.workers, Role.SrManager],
    },
    {
      type: MessageType.privateMessage,
      subjectAllowed: true,
      name: 'soukromá zpráva',
      nameInDeclination: 'soukromou zprávu',
      hasRecipient: true,
      order: 1,
      attachmentAllowed: true,
      allowedRoles: RoleGroup.all,
    },
    {
      type: MessageType.sms,
      name: 'sms',
      subjectAllowed: false,
      nameInDeclination: 'sms',
      hasRecipient: true,
      order: 2,
      attachmentAllowed: false,
      allowedRoles: [Role.Superadmin, Role.Admin, Role.OaCoordinator],
    },
  ]
  private static TAG = 'MessageModes'

  static getByType(msgType: MessageType) {
    return this.MODES.find((m) => m.type === msgType)
  }

  static getByTabName(msgTabName: MessagingTabName) {
    switch (msgTabName) {
      case MessagingTabName.ANNOUNCEMENTS:
        return this.getByType(MessageType.announcement)
      case MessagingTabName.PRIVATE_MESSAGES:
        return this.getByType(MessageType.privateMessage)
      case MessagingTabName.SMS:
        return this.getByType(MessageType.sms)
      default:
        break
    }
  }

  static async createMessage(mode: MessageMode, usersService: UsersService, opts: CreateMessageOpts) {
    console.log(this.TAG, 'createMessage', opts)
    switch (mode.type) {
      case MessageType.announcement:
        return Announcement.createFromProps(Announcement, opts)
      case MessageType.privateMessage:
        return PrivateMessage.createFromProps(PrivateMessage, opts)
      case MessageType.sms:
        try {
          const primaryContact = await usersService.getUsersPrimaryPhoneContact(opts.recipient.id)

          return SmsMessage.createFromProps(SmsMessage, {
            contactId: primaryContact.id,
            contact: primaryContact,
            body: opts.content,
            number: primaryContact.content,
            smsDirection: 'out',
          })
        } catch (e) {
          console.error('Error sending sms')
          throw e
        }
      default:
        throw new Error('Invalid message type')
    }
  }
}
